import Honeycomb from './Honeycomb';
export default Honeycomb;
